import React, { useState, useEffect, useContext } from "react";
import { Images } from "../../theme";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalContext";
import { DotsLoader, NoDataFound } from "../";
import "./style.css";

export default (props) => {
  const getcategory = useContext(GlobalContext);
  let { get_categories, imageUrl, isLoading, categoryData } = getcategory;

  useEffect(() => {
    get_categories();
  }, []);

  return (
    <div className="d-flex flex-wrap mt-3 card-main">
      {isLoading ? (
        <DotsLoader />
      ) : categoryData?.length ? (
        categoryData?.map((val) => {
          return (
            <Link
              className="search-card"
              to="/searchbycategory"
              state={{ data: val }}
            >
              <img className="w-100" src={`${imageUrl}${val.imagePath}`} />
              <p className="color-white MontserratSemiBold text-search-card">
                {val.name}
              </p>
            </Link>
          );
        })
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};
